import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-confirm-delete-modal',
    templateUrl: './confirm-delete-modal.component.html',
    styleUrls: ['./confirm-delete-modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class ConfirmDeleteModalComponent implements OnInit {
    public title: string;
    public areYouSureText: string;
    public itemTitle: string;

    @Output() confirmed = new EventEmitter<any>();
    @Output() cancelled = new EventEmitter<any>();

    constructor(public bsModalRef: BsModalRef, private router: Router) {}

    ngOnInit() {
        this.closeOnRouteChange();
    }

    public confirmButton(): void {
        this.confirmed.emit();
        this.bsModalRef.hide();
    }

    public cancelButton(): void {
        this.cancelled.emit();
        this.bsModalRef.hide();
    }

    private closeOnRouteChange(): void {
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            this.bsModalRef.hide();
        });
    }
}
